"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndicatorGroup = void 0;
var utils_1 = require("../../utils");
exports.IndicatorGroup = {
  name: 'IndicatorGroup',
  label: 'Indicator Group',
  type: 'taxonomy',
  icon: function (_a) {
    var icons = _a.icons;
    return icons.Entities.IndicatorGroup;
  },
  autoRoutes: ['list', 'create', 'update'],
  table: {
    fieldNames: ["info", "layout", "indicators"],
    fields: {
      info: {
        title: 'Info'
      },
      layout: {
        title: 'Layout'
      },
      indicators: {
        title: 'Indicators'
      }
    }
  },
  list: {
    resultsVariant: 'table'
  },
  form: {
    fields: __assign(__assign({}, utils_1.entityStandardFormFields), {
      label: {
        type: 'text',
        description: "Provide an alternative label used for displaying this {{INDICATOR_GROUP}}. If not provided, the name will be used instead."
      },
      description: {
        type: 'longText',
        description: "Describe this {{INDICATOR_GROUP}}."
      },
      indicators: {
        type: 'linkedMultiple',
        description: "Which {{INDICATORS}} belong to this group?",
        entityTypeName: 'Indicator'
      },
      layout: {
        type: 'linked',
        label: "Layout",
        entityTypeName: 'IndicatorGroupLayout',
        fieldSet: 'overview',
        description: "Select the {{INDICATOR_GROUP_LAYOUT}} used to present {{INDICATOR_RESULTS}} whose {{INDICATOR}} is part of this group."
      },
      icon: {
        type: 'linked',
        entityTypeName: 'Icon',
        fieldSet: 'overview'
      },
      unit: {
        type: 'linked',
        entityTypeName: 'Unit',
        fieldSet: 'overview',
        description: "Select the {{UNIT}} used as a default for all {{INDICATORS}} in this group."
      }
    })
  }
};